import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  siteEmailSettingsRequest,
  siteEmailSettingsSuccess,
  siteEmailSettingsFailure,
  siteEmailRecipientsSuccess,
  siteEmailRecipientsFailure,
  siteEmailRecipientsRequest,
  updateSiteEmailRecipientsRequest,
  updateSiteEmailRecipientsSuccess,
  updateSiteEmailRecipientsFailure,
  updateSiteEmailSettingRequest,
  updateSiteEmailSettingFailure,
  updateSiteEmailSettingSuccess,
} from './actions';
import axios from 'axios';
import { SITES_V2 } from 'app/api-routes';

function* siteEmailSettingsSaga({ payload: siteID }) {
  try {
    const { payload } = yield axios.get(`${SITES_V2}/${siteID}/email-settings`);
    yield put(siteEmailSettingsSuccess({ siteID, settings: payload }));
  } catch (err) {
    yield put(siteEmailSettingsFailure(err));
  }
}

function* updateSiteEmailSettingSaga({ payload: { siteID, type, enabled, visibleOnClientPortal } }) {
  try {
    yield axios.put(`${SITES_V2}/${siteID}/email-settings/${type}`, {
      payload: { enabled, visibleOnClientPortal },
    });
    yield call(siteEmailSettingsSaga, { payload: siteID });
    yield put(updateSiteEmailSettingSuccess({ siteID, type, enabled, visibleOnClientPortal }));
  } catch (err) {
    yield put(updateSiteEmailSettingFailure(err));
  }
}

function* siteEmailRecipientsSaga({ payload: { siteID, type } }) {
  try {
    const { payload } = yield axios.get(`${SITES_V2}/${siteID}/email-recipients`, { params: { type } });
    yield put(siteEmailRecipientsSuccess({ recipients: payload }));
  } catch (err) {
    yield put(siteEmailRecipientsFailure(err));
  }
}

function* updateSiteEmailRecipientsSaga({ payload: { siteID, type, values } }) {
  try {
    yield axios.post(
      `${SITES_V2}/${siteID}/email-recipients`,
      { payload: values },
      {
        params: { type },
      }
    );

    yield call(siteEmailSettingsSaga, { payload: siteID });
    yield put(updateSiteEmailRecipientsSuccess({ siteID, type, payload: values }));
  } catch (err) {
    yield put(updateSiteEmailRecipientsFailure(err));
  }
}

export default function* () {
  yield all([
    yield takeLatest(siteEmailSettingsRequest, siteEmailSettingsSaga),
    yield takeLatest(updateSiteEmailSettingRequest, updateSiteEmailSettingSaga),
    yield takeLatest(siteEmailRecipientsRequest, siteEmailRecipientsSaga),
    yield takeLatest(updateSiteEmailRecipientsRequest, updateSiteEmailRecipientsSaga),
  ]);
}
